import loader from './lib/Loader';

import(/* webpackPrefetch: true */ './icons');
loader('slider', '.slider');
loader('quote-slider', '.quote-slider');
loader('navbar', '.header');
loader('menu', '.menu');
loader('newsletter-form', '.newsletter-form');
loader('images-popup', '.image-grid__more-images');
loader('popup', '.overlay');
loader('member-validation', '#tribe-tickets__registration-form');
loader('copy-text', '.copy-text');
loader('gallery-archive', '.gallery-events__filter');
loader('faq', '.faq');
loader('filter', '.event-overview__filter');
loader('video', 'video');
loader('ticket-count', '.tribe-tickets__tickets-item-quantity-add');
loader('shoptable-count', '.shop_table');
loader('image-gallery-slider', '.image-slider-swiper');
